import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/igssDependency';
import IgssDependenciesCrear from './IgssDependenciesCrear';
import { resetStore } from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.igss_dependencies,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(IgssDependenciesCrear);
